/**
 * Rosewyn - Kaching Bundles storefront helpers.
 *
 * 1. Subscription-only mode. Kaching renders an opt-in "Save 25% with Automatic
 *    Refills" toggle. We tick it as soon as the widget renders; the row itself
 *    is hidden by CSS in layout/theme.liquid. If the toggle refuses to stick we
 *    add `ks-force-failed` to <html>, which un-hides it so the customer always
 *    has a working purchase path.
 *
 * 2. Per-bundle refill note. The line under Add to Cart swaps to match the
 *    selected bundle. Copy comes from data attributes on .phs__refill-note,
 *    which are set from theme settings in sections/new-hero.liquid - so the
 *    wording is edited in the theme customiser, never in here.
 */
(function () {
  var TOGGLE_SELECTOR = '.kaching-bundles__subscriptions [role="checkbox"][aria-checked]';
  var NOTE_SELECTOR = '.phs__refill-note';
  var BLOCK_SELECTOR = 'kaching-bundles-block';
  var MAX_ATTEMPTS = 8;

  var attempts = new WeakMap();
  var forceScheduled = false;
  var noteScheduled = false;
  var noteObserver = null;

  /* ---------------------------------------------------------- subscription */

  function markFailed() {
    document.documentElement.classList.add('ks-force-failed');
  }

  function markOk() {
    document.documentElement.classList.remove('ks-force-failed');
  }

  function forceOn() {
    var toggles = document.querySelectorAll(TOGGLE_SELECTOR);

    for (var i = 0; i < toggles.length; i++) {
      var toggle = toggles[i];

      if (toggle.getAttribute('aria-checked') === 'true') {
        attempts.delete(toggle);
        markOk();
        continue;
      }

      var tried = attempts.get(toggle) || 0;

      if (tried >= MAX_ATTEMPTS) {
        markFailed();
        continue;
      }

      attempts.set(toggle, tried + 1);
      toggle.click();
    }
  }

  function scheduleForce() {
    if (forceScheduled) return;
    forceScheduled = true;
    requestAnimationFrame(function () {
      forceScheduled = false;
      forceOn();
      attachNoteObserver();
    });
  }

  /* ----------------------------------------------------------- refill note */

  function parseJsonAttribute(element, name) {
    try {
      return JSON.parse(element.getAttribute(name) || '{}');
    } catch (error) {
      return {};
    }
  }

  // Total bottles the bar puts in the cart. A plain bar carries `quantity`;
  // a buy-X-get-Y bar carries `buyQuantity` plus `getQuantity`.
  function bottlesInBar(bar) {
    var base = bar.quantity != null ? bar.quantity : bar.buyQuantity;
    var paid = Number(base) || 1;
    var free = Number(bar.getQuantity) || 0;
    return paid + free;
  }

  function syncRefillNote() {
    var note = document.querySelector(NOTE_SELECTOR);
    if (!note) return;

    var block = document.querySelector(BLOCK_SELECTOR);
    if (!block) return;

    var selected = block.querySelector('.kaching-bundles__bar--selected[data-deal-bar-id]');
    if (!selected) return;

    var config = parseJsonAttribute(block, 'deal-block');
    var bars = config.dealBars || [];
    var barId = selected.getAttribute('data-deal-bar-id');
    var bar = null;

    for (var i = 0; i < bars.length; i++) {
      if (bars[i].id === barId) {
        bar = bars[i];
        break;
      }
    }

    if (!bar) return;

    var text =
      note.getAttribute('data-refill-' + bottlesInBar(bar)) ||
      note.getAttribute('data-refill-default') ||
      '';

    if (!text) return;

    // The note lives outside the Kaching block, so writing to it here cannot
    // re-trigger the observer below.
    if (note.textContent !== text) note.textContent = text;
  }

  function scheduleNote() {
    if (noteScheduled) return;
    noteScheduled = true;
    requestAnimationFrame(function () {
      noteScheduled = false;
      syncRefillNote();
    });
  }

  function attachNoteObserver() {
    if (noteObserver) return;

    var block = document.querySelector(BLOCK_SELECTOR);
    if (!block) return;

    noteObserver = new MutationObserver(scheduleNote);
    noteObserver.observe(block, {
      attributes: true,
      attributeFilter: ['class', 'deal-block', 'product'],
      childList: true,
      subtree: true,
    });

    scheduleNote();
  }

  /* ------------------------------------------------------------- bootstrap */

  scheduleForce();

  new MutationObserver(scheduleForce).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-checked'],
  });

  // Kaching updates the selected bar after the click resolves, so re-read on
  // the next frame and again once its state has settled.
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;
      if (!event.target.closest('.kaching-bundles__bar')) return;
      scheduleNote();
      setTimeout(scheduleNote, 150);
    },
    true
  );

  document.addEventListener('shopify:section:load', function () {
    noteObserver = null;
    scheduleForce();
  });

  setTimeout(function () {
    var toggle = document.querySelector(TOGGLE_SELECTOR);
    if (toggle && toggle.getAttribute('aria-checked') !== 'true') markFailed();
  }, 6000);
})();
